/**
 * Kabinetga kirish usullari — login, OneID, E-imzo, USB token (uz / ru / en).
 * `index.tsx` asosiy lug'atlarga qo'shadi; bu yerdagi kalit shu yerdan ustun turadi.
 */
type Dict = Record<string, string>;

export const loginUz: Dict = {
  "auth.tab.email": "Login",
  "auth.tab.oneid": "OneID",
  "auth.tab.eimzo": "E-imzo",
  "auth.tab.token": "USB token",

  /* ---- E-imzo (ERI kaliti) ---- */
  "eri.title": "E-imzo kaliti bilan kirish",
  "eri.sub": "Kompyuteringizdagi E-IMZO dasturi va elektron raqamli imzo (ERI) kaliti orqali kiradi.",
  "eri.checking": "E-IMZO dasturi tekshirilmoqda…",
  "eri.missing.title": "E-IMZO dasturi topilmadi",
  "eri.missing.text":
    "Dasturni o'rnating yoki ishga tushiring (e-imzo.uz), so'ng «Qayta qidirish» tugmasini bosing.",
  "eri.noKeys": "ERI kaliti topilmadi. Kalit fayli (PFX) yoki ID-karta shu kompyuterda ekanini tekshiring.",
  "eri.rescan": "Qayta qidirish",
  "eri.pick": "Kalitni tanlang",
  "eri.validTo": "Amal qiladi",
  "eri.submit": "E-imzo bilan kirish",
  "eri.signing": "E-IMZO dasturida kalit parolini kiriting…",
  "eri.privacy":
    "Kalit paroli faqat E-IMZO dasturida kiritiladi: maxfiy kalit brauzer va serverga chiqmaydi.",
  "eri.unavailable":
    "Imzo bilan kirish hozircha yoqilmagan: E-IMZO tekshiruv xizmati ulanmagan. Login, OneID yoki USB token'dan foydalaning.",
  "eri.err.generic": "Imzolab bo'lmadi. Kalitni va parolni tekshirib, qayta urinib ko'ring.",

  /* ---- Smart Forestry USB tokeni ---- */
  "token.title": "USB token bilan kirish",
  "token.sub": "Smart Forestry'ning o'z USB tokeni: ulang, PIN kiriting — parol kerak emas.",
  "token.access": "Token egasi hisobining barcha huquqlari bilan, to'liq tizimga kiradi.",
  "token.step1": "Tokenni kompyuterning USB portiga ulang",
  "token.step2": "«Token bilan kirish» tugmasini bosing va token PIN-kodini kiriting",
  "token.email": "Login (ixtiyoriy)",
  "token.emailHint": "Token hisobni o'zi tanimasa, e-pochtangizni kiriting.",
  "token.submit": "Token bilan kirish",
  "token.working": "Tokenni tasdiqlang…",
  "token.unsupported":
    "Brauzeringiz USB tokenni qo'llamaydi yoki sahifa HTTPS orqali ochilmagan. Zamonaviy Chrome, Edge yoki Firefox'dan foydalaning.",
  "token.notRegistered":
    "Token hali ro'yxatdan o'tmagan bo'lsa: login yoki OneID bilan kiring, so'ng «Profil → USB token» bo'limida qo'shing.",
  "token.err.cancelled": "Tasdiqlash bekor qilindi yoki vaqt tugadi. Tokenni ulab, qayta urinib ko'ring.",
  "token.err.exists": "Bu token hisobingizga allaqachon qo'shilgan.",
  "token.err.security": "Brauzer bu manzil uchun tokenga ruxsat bermadi (faqat HTTPS va haqiqiy domen).",
  "token.err.unsupported": "Bu token yoki brauzer kerakli usulni (FIDO2, PIN) qo'llamaydi.",
  "token.err.generic": "Token bilan bog'lanib bo'lmadi. Tokenni qayta ulab, urinib ko'ring.",

  /* ---- Profil: tokenlarni boshqarish ---- */
  "token.card.title": "USB token",
  "token.card.sub": "Smart Forestry tokeni bilan parolsiz, to'liq huquq bilan kirish",
  "token.card.empty": "Hisobingizga hali token qo'shilmagan.",
  "token.card.name": "Token nomi",
  "token.card.namePh": "Masalan: Asosiy token",
  "token.card.add": "Token qo'shish",
  "token.card.adding": "Tokenni tasdiqlang…",
  "token.card.added": "Token qo'shildi. Endi u bilan kirish mumkin.",
  "token.card.lastUsed": "Oxirgi kirish",
  "token.card.never": "hali kirilmagan",
  "token.card.remove": "O'chirish",
  "token.card.confirm": "Tasdiqlash",
  "token.card.removed": "Token o'chirildi.",
  "token.card.warn":
    "Token egasi hisobingizning barcha huquqlari bilan kiradi. Tokenni begonalarga bermang; yo'qolsa — darhol o'chiring.",
};

export const loginRu: Dict = {
  "auth.tab.email": "Логин",
  "auth.tab.oneid": "OneID",
  "auth.tab.eimzo": "E-imzo",
  "auth.tab.token": "USB-токен",

  "eri.title": "Вход по ключу E-imzo",
  "eri.sub": "Через программу E-IMZO и ключ электронной цифровой подписи (ЭЦП) на вашем компьютере.",
  "eri.checking": "Проверяем программу E-IMZO…",
  "eri.missing.title": "Программа E-IMZO не найдена",
  "eri.missing.text": "Установите или запустите программу (e-imzo.uz), затем нажмите «Найти снова».",
  "eri.noKeys": "Ключ ЭЦП не найден. Убедитесь, что файл ключа (PFX) или ID-карта есть на этом компьютере.",
  "eri.rescan": "Найти снова",
  "eri.pick": "Выберите ключ",
  "eri.validTo": "Действует до",
  "eri.submit": "Войти по E-imzo",
  "eri.signing": "Введите пароль ключа в программе E-IMZO…",
  "eri.privacy":
    "Пароль ключа вводится только в программе E-IMZO: закрытый ключ не покидает компьютер и не передаётся на сервер.",
  "eri.unavailable":
    "Вход по подписи пока не включён: не подключён сервис проверки E-IMZO. Используйте логин, OneID или USB-токен.",
  "eri.err.generic": "Не удалось подписать. Проверьте ключ и пароль и повторите попытку.",

  "token.title": "Вход по USB-токену",
  "token.sub": "Собственный USB-токен Smart Forestry: подключите, введите PIN — пароль не нужен.",
  "token.access": "Владелец токена входит со всеми правами своей учётной записи — с полным доступом к системе.",
  "token.step1": "Подключите токен к USB-порту компьютера",
  "token.step2": "Нажмите «Войти по токену» и введите PIN-код токена",
  "token.email": "Логин (необязательно)",
  "token.emailHint": "Если токен не определяет учётную запись сам, введите вашу почту.",
  "token.submit": "Войти по токену",
  "token.working": "Подтвердите на токене…",
  "token.unsupported":
    "Ваш браузер не поддерживает USB-токены или страница открыта не по HTTPS. Используйте современный Chrome, Edge или Firefox.",
  "token.notRegistered":
    "Если токен ещё не зарегистрирован: войдите по логину или OneID и добавьте его в «Профиль → USB-токен».",
  "token.err.cancelled": "Подтверждение отменено или время вышло. Подключите токен и повторите попытку.",
  "token.err.exists": "Этот токен уже добавлен в вашу учётную запись.",
  "token.err.security": "Браузер не разрешил доступ к токену для этого адреса (нужен HTTPS и настоящий домен).",
  "token.err.unsupported": "Токен или браузер не поддерживает нужный способ (FIDO2, PIN).",
  "token.err.generic": "Не удалось связаться с токеном. Переподключите его и повторите попытку.",

  "token.card.title": "USB-токен",
  "token.card.sub": "Вход токеном Smart Forestry без пароля и с полными правами",
  "token.card.empty": "К вашей учётной записи пока не добавлен токен.",
  "token.card.name": "Название токена",
  "token.card.namePh": "Например: основной токен",
  "token.card.add": "Добавить токен",
  "token.card.adding": "Подтвердите на токене…",
  "token.card.added": "Токен добавлен. Теперь им можно входить.",
  "token.card.lastUsed": "Последний вход",
  "token.card.never": "ещё не входили",
  "token.card.remove": "Удалить",
  "token.card.confirm": "Подтвердить",
  "token.card.removed": "Токен удалён.",
  "token.card.warn":
    "Владелец токена входит со всеми правами вашей учётной записи. Не передавайте токен посторонним; если потеряли — сразу удалите.",
};

export const loginEn: Dict = {
  "auth.tab.email": "Login",
  "auth.tab.oneid": "OneID",
  "auth.tab.eimzo": "E-imzo",
  "auth.tab.token": "USB token",

  "eri.title": "Sign in with an E-imzo key",
  "eri.sub": "Through the E-IMZO app and your electronic digital signature (EDS) key on this computer.",
  "eri.checking": "Checking for the E-IMZO app…",
  "eri.missing.title": "E-IMZO app not found",
  "eri.missing.text": "Install or start the app (e-imzo.uz), then press “Search again”.",
  "eri.noKeys": "No EDS key found. Make sure the key file (PFX) or ID card is on this computer.",
  "eri.rescan": "Search again",
  "eri.pick": "Choose a key",
  "eri.validTo": "Valid until",
  "eri.submit": "Sign in with E-imzo",
  "eri.signing": "Enter the key password in the E-IMZO app…",
  "eri.privacy":
    "The key password is typed only into the E-IMZO app: the private key never leaves your computer or reaches the server.",
  "eri.unavailable":
    "Signature sign-in is not enabled yet: the E-IMZO verification service is not connected. Use login, OneID or a USB token.",
  "eri.err.generic": "Could not sign. Check the key and password and try again.",

  "token.title": "Sign in with a USB token",
  "token.sub": "Smart Forestry's own USB token: plug it in, enter the PIN — no password needed.",
  "token.access": "The token holder signs in with all rights of the account — full access to the system.",
  "token.step1": "Plug the token into a USB port",
  "token.step2": "Press “Sign in with token” and enter the token PIN",
  "token.email": "Login (optional)",
  "token.emailHint": "If the token does not pick the account by itself, enter your e-mail.",
  "token.submit": "Sign in with token",
  "token.working": "Confirm on the token…",
  "token.unsupported":
    "Your browser does not support USB tokens or the page is not served over HTTPS. Use a current Chrome, Edge or Firefox.",
  "token.notRegistered":
    "If the token is not registered yet: sign in with login or OneID and add it under “Profile → USB token”.",
  "token.err.cancelled": "Confirmation cancelled or timed out. Plug the token in and try again.",
  "token.err.exists": "This token is already added to your account.",
  "token.err.security": "The browser did not allow the token for this address (HTTPS and a real domain are required).",
  "token.err.unsupported": "The token or the browser does not support the required method (FIDO2, PIN).",
  "token.err.generic": "Could not reach the token. Re-plug it and try again.",

  "token.card.title": "USB token",
  "token.card.sub": "Sign in with a Smart Forestry token — no password, full rights",
  "token.card.empty": "No token has been added to your account yet.",
  "token.card.name": "Token name",
  "token.card.namePh": "For example: main token",
  "token.card.add": "Add token",
  "token.card.adding": "Confirm on the token…",
  "token.card.added": "Token added. You can now sign in with it.",
  "token.card.lastUsed": "Last sign-in",
  "token.card.never": "never used",
  "token.card.remove": "Remove",
  "token.card.confirm": "Confirm",
  "token.card.removed": "Token removed.",
  "token.card.warn":
    "The token holder signs in with all rights of your account. Do not hand the token to others; if it is lost, remove it immediately.",
};
